import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import useHeaderData from "./useHeaderNavData";

const NewHeader = () => {
  const headerItems = useHeaderData();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  const handleToggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  // Close menu on route change
  useEffect(() => {
    closeMobileMenu();
  }, [location]);

  return (
    <>
      <div>
        <nav
          className={`block lg:hidden  w-full`}
          style={{ backgroundColor: "white" }}
        >
          <ul className="md:flex md:gap-4 items-start md:items-center py-2 md:py-0 navbar-nav">
            {headerItems.map((item, index) => (
              <li
                key={index}
                className="nav-item group relative px-2"
                style={{ color: "#000000" }}
              >
                <div
                  className="flex items-center justify-between md:block w-full text-uppercase cursor-pointer group-hover:text-red-600 transition-colors"
                  onClick={() =>
                    item.dropdown
                      ? handleToggleDropdown(index)
                      : closeMobileMenu()
                  }
                >
                  {item.external ? (
                    <Link
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link text-base font-medium text-red-900 transition block py-2 px-2 md:px-4  text-uppercase"
                      style={{ color: "#000000" }}
                    >
                      {item.title}
                    </Link>
                  ) : (
                    <Link
                      to={item.link}
                      className="nav-link text-base font-medium text-red-900 transition block py-2 px-2 md:px-4  text-uppercase"
                      style={{ color: "#000000" }}
                    >
                      {item.title}
                    </Link>
                  )}
                </div>

                {/* Dropdown */}
                {item.dropdown && (
                  <ul
                    className={`simple-dropdown-menu rounded-md shadow-md transition-all overflow-hidden z-50 ${
                      activeDropdown === index || window.innerWidth >= 768
                        ? "block"
                        : "hidden"
                    } md:absolute md:left-0 md:top-full md:mt-1 md:w-48`}
                  >
                    {item.dropdown.map((subItem, subIndex) => (
                      <li
                        key={subIndex}
                        className="simple-dropdown px-4 py-2 hover:bg-gray-100"
                      >
                        {subItem.external ? (
                          <Link
                            to={subItem.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block text-gray-800 hover:text-red-600"
                          >
                            {subItem.title}
                          </Link>
                        ) : (
                          <Link
                            to={subItem.link}
                            className="block text-gray-800 hover:text-red-600"
                          >
                            {subItem.title}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
      {/* <div
        className={`mobile-menu fixed top-0 right-0 h-full w-80 max-w-[85vw] sm:w-96 bg-[#D0F0C0] shadow-xl transform transition-transform duration-300 ease-in-out z-50 lg:hidden ${
          mobileMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center p-4 border-b border-gray-300">
          <div className="flex items-center">
            <img
              src="/assets/logo/Logo-Final-C2C.png"
              alt="logo"
              width="100"
              height="38"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "block";
              }}
            />
            <span
              className="text-lg font-bold hidden"
              style={{ color: "#000000" }}
            >
              ECOBUILD
            </span>
          </div>
          <button
            onClick={closeMobileMenu}
            className="p-2 rounded-md hover:bg-gray-200 transition-colors"
          >
            <i className="fas fa-times text-xl" style={{ color: "#000000" }} />
          </button>
        </div>{" "}
        <nav className="p-4 overflow-y-auto h-full">
          <ul className="space-y-1">
            {headerItems.map((item, index) => (
              <li
                key={index}
                className="border-b border-gray-300 last:border-b-0"
              >
                <div className="">
                  <div
                    className="flex items-center justify-between cursor-pointer group"
                    onClick={() => {
                      if (item.dropdown) {
                        handleToggleDropdown(index);
                      } else {
                        closeMobileMenu();
                      }
                    }}
                  >
                    <Link
                      to={item.link}
                      className="text-base font-semibold py-2 flex-1 hover:text-red-600 transition-colors uppercase tracking-wide"
                      style={{ color: "#000000" }}
                      onClick={(e) => {
                        if (item.dropdown) {
                          e.preventDefault();
                        } else {
                          closeMobileMenu();
                        }
                      }}
                    >
                      {item.title}
                    </Link>

                    {item.dropdown && (
                      <i
                        className={`fas fa-chevron-down transition-transform ml-2 text-sm ${
                          activeDropdown === index ? "rotate-180" : ""
                        }`}
                        style={{ color: "#000000" }}
                      />
                    )}
                  </div>
                  {item.dropdown && (
                    <ul
                      className={`mt-2 ml-4 space-y-1 transition-all bg-light duration-300 overflow-hidden ${
                        activeDropdown === index
                          ? "max-h-96 opacity-100"
                          : "max-h-0 opacity-0"
                      }`}
                    >
                      {item.dropdown.map((subItem, subIndex) => (
                        <li key={subIndex} className="">
                          <Link
                            to={subItem.link}
                            className="block py-2 px-3 text-sm font-medium rounded-md hover:bg-white hover:bg-opacity-50 transition-colors"
                            style={{ color: "#000000" }}
                            onClick={closeMobileMenu}
                          >
                            {subItem.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="flex justify-between items-center px-4 py-3 lg:hidden">
        <img
          src="/assets/logo/Logo-Final-C2C.png"
          alt="logo"
          className="w-[100px]"
        />
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="text-2xl text-gray-800 focus:outline-none"
        >
          <i className={`fas ${mobileMenuOpen ? "fa-xmark" : "fa-bars"}`} />
        </button>
      </div>
      <div
        className={`fixed top-0 right-0 h-full w-[80%] sm:w-[60%] bg-[#D0F0C0] shadow-xl transform transition-transform duration-300 ease-in-out z-50 ${
          mobileMenuOpen ? "translate-x-0" : "translate-x-full"
        } lg:hidden`}
      >
        <div className="flex justify-between items-center p-4 border-b border-gray-300">
          <img
            src="/assets/logo/Logo-Final-C2C.png"
            alt="logo"
            width="100"
            height="38"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "block";
            }}
          />
          <button onClick={closeMobileMenu} className="text-2xl text-gray-800">
            <i className="fas fa-xmark" />
          </button>
        </div>
        <nav className="p-4 overflow-y-auto h-full">
          <ul className="space-y-1">
            {headerItems.map((item, index) => (
              <li
                key={index}
                className="border-b border-gray-300 last:border-b-0"
              >
                <div
                  className="flex items-center justify-between cursor-pointer"
                  onClick={() =>
                    item.dropdown
                      ? handleToggleDropdown(index)
                      : closeMobileMenu()
                  }
                >
                  <Link
                    to={item.link}
                    className="text-base font-semibold py-2 flex-1 hover:text-red-600 uppercase tracking-wide"
                    style={{ color: "#000000" }}
                    onClick={(e) => {
                      if (item.dropdown) {
                        e.preventDefault();
                      } else {
                        closeMobileMenu();
                      }
                    }}
                  >
                    {item.title}
                  </Link>
                  {item.dropdown && (
                    <i
                      className={`fas fa-chevron-down ml-2 text-sm transition-transform ${
                        activeDropdown === index ? "rotate-180" : ""
                      }`}
                      style={{ color: "#000000" }}
                    />
                  )}
                </div>
                {item.dropdown && (
                  <ul
                    className={`mt-2 ml-4 space-y-1 transition-all duration-300 overflow-hidden ${
                      activeDropdown === index
                        ? "max-h-96 opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    {item.dropdown.map((subItem, subIndex) => (
                      <li key={subIndex}>
                        <Link
                          to={subItem.link}
                          className="block py-2 px-3 text-sm font-medium rounded-md hover:bg-white hover:bg-opacity-50"
                          style={{ color: "#000000" }}
                          onClick={closeMobileMenu}
                        >
                          {subItem.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div> */}
    </>
  );
};

export default NewHeader;
